export function configureUibTooltip($uibTooltipProvider) {
    'ngInject'
    // Prevent uib tooltip from being cut off when within a container that has overflow: hidden
    $uibTooltipProvider.options({
        appendToBody: true
    });
}
